import "./one-emirate.css";
import {
  Container,
  Tabs,
  Tab,
  Col,
  Row,
  Form,
} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Dentists from './dentists/dentists';
import Clinics from './clinics/clinics';
import AvailableTimes from './available-times/available-times';
// import {useForm} from "react-hook-form";
import './one-emirate.js'
import NearMe from "../../home-page/near-me/near-me";
import {emiratePositions} from '../../lists/emirate-pos-list';
import axios from 'axios';
import ReactGA from 'react-ga';

export default function OneEmirate(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);    
  console.log(props.location.state);
  const google_map_api_key = "AIzaSyBIPhtOla4zatfw4pnL4ww6OyJBQhftUYc"
  const proxyurl = "https://cors-anywhere.herokuapp.com/";
  const fullScreen = 10;
  const minimized = 4;
  const mapColFullSize = 8;

  let emirate = props.location.state.emirate;
  let position = props.location.state.position || emiratePositions[emirate];
  let defaultActiveKey = props.location.state.activeTab || 'times';

  // const {register, handleSubmit} = useForm();
  const [showMap, setShowMap] = useState(false);
  const [mapColWidth, setMapColWidth] = useState(0);
  const [listSize, setListSize] = useState(fullScreen);
  const [offset, setOffset] = useState(1)
  // const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState({state: position});




  useEffect(() => {
    const prediction = props.location.state.prediction;
    if(prediction) {
      console.log(prediction)
      // setLoading(true);
      axios.post(proxyurl+`https://maps.googleapis.com/maps/api/place/details/json?placeid=${prediction.data.place_id}&key=${google_map_api_key}`)
      .then(queryResult => {
        console.log(queryResult.data.result.geometry.location)
        const location = queryResult.data.result.geometry.location;
        setLocation({state: location})
      })
      .catch((err) => console.log(err))
    }
}, [google_map_api_key, props.location.state.prediction]);



  const toggleMap = async () => {
    if (listSize === fullScreen){
      setOffset(0)
      setListSize(minimized);
      setMapColWidth(mapColFullSize)
    } else {
      setListSize(fullScreen)
      setMapColWidth(0)
      setOffset(1)
    }
    setShowMap(!showMap)
  }



    return (
      <Container id='fluidContainer' className="my-2" fluid>
        <Row className='justify-content-lg-center'>
          <Col className='p-1'xs={12} lg={{ span: listSize, offset: offset }} >
          <Tabs defaultActiveKey={defaultActiveKey} id="uncontrolled-tab-example">
            <Tab eventKey="times" title="Book a Time">
              <AvailableTimes emirate={emirate}/>
            </Tab>
            <Tab eventKey="clinics" title="Clinics">
              <Clinics emirate={emirate}/>
            </Tab>
            <Tab eventKey="dentists" title="Dentists">
              <Dentists emirate={emirate}/>
            </Tab>
            {/* <Tab eventKey="map" title="Show Map">
            <NearMe location={location}/>
          </Tab> */}

          </Tabs>
          </Col>


          <Col lg={mapColWidth}>
          <Form>
          <Form.Check 
              className='float-right'
              type="switch"
              id="custom-switch"
              label="Show Map"
              onClick={toggleMap}
            />
          </Form>
          {showMap &&
              <Row className='mt-4'> 
                <NearMe location={location}/>
                </Row>
          }
          </Col>
        </Row>
      </Container>
    );
  }

